import { ComponentType, FC, Suspense, lazy } from 'react';

import { DialogsController as SharedDialogsController } from '@material-bank/mb-uikit/shared/components/DialogsController';

import { DialogConfig } from './config';

export type DialogName = DialogConfig['name'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DIALOG_COMPONENTS_CONFIG: Record<DialogName, ComponentType<any>> = {
  addressValidation: lazy(() => import('../dialogs/AddressValidationDialog')),
  passwordResetLinkSent: lazy(
    () => import('../dialogs/PasswordResetLinkSentDialog'),
  ),
  resetPassword: lazy(() => import('../dialogs/ResetPasswordDialog')),
  professionalMembershipRequirements: lazy(
    () => import('../dialogs/ProfessionalMembershipRequirementsDialog'),
  ),
  enrichUserProfile: lazy(() => import('../dialogs/EnrichUserProfileDialog')),
  completeUserProfile: lazy(
    () => import('../dialogs/CompleteUserProfileDialog'),
  ),
  deleteAddressConfirmation: lazy(
    () => import('../dialogs/DeleteAddressConfirmationDialog'),
  ),
  multiBrandErrorMessage: lazy(
    () => import('../dialogs/MultiBrandErrorMessageDialog'),
  ),
  // @ts-expect-error deprecating SetProjectDialog. Suppressing the error because `mb-uikit` is deprecated as well and will be removed.
  setProject: null,
};

export const DialogsController: FC = () => {
  return (
    <Suspense>
      <SharedDialogsController<DialogConfig>
        dialogComponentsConfig={DIALOG_COMPONENTS_CONFIG}
      />
    </Suspense>
  );
};
